"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let MFixedAssetEditor = class MFixedAssetEditor extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "page",
    };
    beforeCreate() {
    }
    getPayload(...args) {
        const [data] = args;
        if (!this.target) {
            return data;
        }
        const fieldsToSubmit = this.targetConfig[this.target].fieldsToSubmit;
        if (fieldsToSubmit.indexOf('*') > -1) {
            return data;
        }
        return _.pick(data, fieldsToSubmit);
    }
    fixedAsset;
    onFixed_asset(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("fixedAsset");
    }
    target;
    onTarget(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("target");
    }
    size;
    onSize(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("size");
    }
    formId;
    async $$load_formId() {
        return this.$fn.randomElementId();
    }
    defaultTitle;
    targetConfig;
    ux;
    b_7315092382398562_modalBindings;
    dataMembers = ['formId', 'defaultTitle', 'targetConfig', 'ux', 'b_7315092382398562_modalBindings'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                formId: null,
                defaultTitle: this.$fn.pgettext("FixedAsset", "Edit General Information"),
                targetConfig: {
                    general: {
                        title: this.$fn.pgettext("FixedAsset", "Edit general data"),
                        fieldsToSubmit: ["*",
                        ],
                    },
                    wasteBin: {
                        title: this.$fn.pgettext("FixedAsset", "Edit waste bin data"),
                        fieldsToSubmit: ["id",
                            "etag",
                            "waste_bin",
                        ],
                    },
                },
                ux: null,
                b_7315092382398562_modalBindings: {
                    size: "md",
                },
            },
        };
    }
    get document() {
        if (this.loaded) {
            return {
                title: this.target ? this.targetConfig[this.target].title : this.defaultTitle,
            };
        }
        return null;
    }
    async act_7315092382398562_closeModal_1946_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
                cancel: true,
            },
        };
    }
    async evh_7315092382398562_close(event, scope) {
        return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
    }
    async evh_2248226175642056_close(event, scope) {
        return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
    }
    async act_1040167445267876_closeComponent_1952_getActionArgs($event) {
        return {
            result: {
                ok: true,
                value: $event.data,
            },
        };
    }
    async act_1040167445267876_crud_1950_getActionArgs($event) {
        return {
            objectType: "fixed_asset",
            op: "upsert",
            data: this.getPayload(this.fixedAsset),
        };
    }
    async evh_1040167445267876_submit(event, scope) {
        return await this.actions.evh_1040167445267876_submit.executeFromDOM(this, event, scope);
    }
    async evh_1419464017721962_clickPreventStop(event, scope) {
        return await this.actions.evh_1419464017721962_clickPreventStop.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_closeModal_1946 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_7315092382398562_closeModal_1946_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_close_1945 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_closeModal_1946,
            event: "close",
            displayName: "closeModal",
        });
        const evh_7315092382398562_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_close_1945],
        });
        const act_2248226175642056_closeComponent_1948 = new core_1.actions.CloseComponentAction({
            events: [],
        });
        const evh_2248226175642056_close_1947 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_closeComponent_1948,
            event: "close",
            displayName: "closeComponent",
        });
        const evh_2248226175642056_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2248226175642056_close_1947],
        });
        const act_1040167445267876_closeComponent_1952 = new core_1.actions.CloseComponentAction({
            actionArgs: this.act_1040167445267876_closeComponent_1952_getActionArgs,
            events: [],
        });
        const evh_1040167445267876_success_1951 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_closeComponent_1952,
            event: "success",
            displayName: "closeComponent",
        });
        const act_1040167445267876_crud_1950 = new core_1.actions.CRUDAction({
            actionArgs: this.act_1040167445267876_crud_1950_getActionArgs,
            displayName: "save",
            events: [evh_1040167445267876_success_1951],
        });
        const evh_1040167445267876_submit_1949 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_crud_1950,
            event: "submit",
            displayName: "save",
        });
        const evh_1040167445267876_submit = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1040167445267876_submit_1949],
        });
        const act_1419464017721962_closeComponent_1954 = new core_1.actions.CloseComponentAction({
            events: [],
        });
        const evh_1419464017721962_clickPreventStop_1953 = new core_1.actions.EventHandlerImpl({
            action: act_1419464017721962_closeComponent_1954,
            event: "click.prevent.stop",
            displayName: "closeComponent",
        });
        const evh_1419464017721962_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1419464017721962_clickPreventStop_1953],
        });
        return {
            act_7315092382398562_closeModal_1946,
            evh_7315092382398562_close_1945,
            evh_7315092382398562_close,
            act_2248226175642056_closeComponent_1948,
            evh_2248226175642056_close_1947,
            evh_2248226175642056_close,
            act_1040167445267876_closeComponent_1952,
            evh_1040167445267876_success_1951,
            act_1040167445267876_crud_1950,
            evh_1040167445267876_submit_1949,
            evh_1040167445267876_submit,
            act_1419464017721962_closeComponent_1954,
            evh_1419464017721962_clickPreventStop_1953,
            evh_1419464017721962_clickPreventStop,
            save: act_1040167445267876_crud_1950,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: Object,
    }),
    __metadata("design:type", Object)
], MFixedAssetEditor.prototype, "fixedAsset", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('fixedAsset'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], MFixedAssetEditor.prototype, "onFixed_asset", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
    }),
    __metadata("design:type", String)
], MFixedAssetEditor.prototype, "target", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('target'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], MFixedAssetEditor.prototype, "onTarget", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "md",
    }),
    __metadata("design:type", String)
], MFixedAssetEditor.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('size'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], MFixedAssetEditor.prototype, "onSize", null);
MFixedAssetEditor = __decorate([
    (0, vue_property_decorator_1.Component)()
], MFixedAssetEditor);
exports.default = MFixedAssetEditor;
vue_property_decorator_1.Vue.component("MFixedAssetEditor", MFixedAssetEditor);
